export default "__VITE_ASSET__B2UjYv8S__"